import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  MotifButton,
  MotifChip,
  MotifIcon,
  MotifProgressLoader,
  MotifErrorMessage,
  MotifAccordion,
  MotifAccordionTrigger,
  MotifAccordionContent,
  MotifIconButton,
  MotifCheckbox,
} from "@ey-xd/motif-react";
import { IconoirEditPencil } from "@ey-xd/motif-icon";
import {
  useGetclaimStageAndDocumentApiDataQuery,
  useGetClaimStatusApiDataQuery,
  useGetClaimSummaryViewApiDataQuery,
} from "@/services/claimSummary/caseSummaryReducer";
import { useNavigate, useParams } from "react-router-dom";
import { dateFunc } from "@/components/Functions/dateFunc";
import StageStatusPopup from "./stageStatusPopup/statgeStatusPopup";
import { DocumentPopUp } from "./documentPopUp/documentPopUp";
import CustomAttributeValue from "@/components/CustomAttribute/CustomAttributeValue";
import { useLazyDownloadDocumentQuery } from "@/services/documents/documentsReducer";
import { useCase } from "@/features/case/use-case";
import { useSelector } from "react-redux";
import { havingEditPermission } from "@/utility/common";
import {
  EDIT_BUTTON_VARIANT,
  getCommonCopyImg,
} from "@/components/Images/CommonImages";
import { AttributeType } from "@/pages/CaseDetail/Configuration/Attributes/type";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import CommonTooltipWrapper from "@/components/Tooltip/CommonTooltipWrapper";
export const ClaimSummary = ({ setEditPage }: any) => {
  const parameter = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading, error } = useGetClaimSummaryViewApiDataQuery(
    parameter?.claimId
  );
  const { data: claimStageData, refetch } =
    useGetclaimStageAndDocumentApiDataQuery(parameter?.claimId);
  const [downloadDocument] = useLazyDownloadDocumentQuery();
  const [showStageEdit, setShowEdit] = useState(false);
  const [showDocumentEdit, setDocumentEdit] = useState(false);
  const [showAttributesWithValue, setShowAttributesWithValue] =
    useState<any>(true);
  const returnValue = (
    attributeType: any,
    value: any,
    picklistDefinitions: any
  ) => {
    switch (attributeType) {
      case AttributeType.FreeText:
        return value.textValue ? value.textValue : undefined;
      case AttributeType.Number:
        return value.numberValue || value.numberValue === 0 ? true : undefined;
      case AttributeType.Boolean:
        if (value.booleanValue === null) {
          return undefined;
        } else {
          if (value.booleanValue) {
            return t("pages.configuration.attributes.createAttribute.yes");
          } else {
            return t("pages.configuration.attributes.createAttribute.no");
          }
        }
      case AttributeType.Date:
        return value.dateValue ? value.dateValue : undefined;
      case AttributeType.SingleSelect:
        const selected = picklistDefinitions.filter((x: any) => {
          return x.id === value.selectedValue;
        });
        return selected.length !== 0 ? selected[0].name : undefined;
      case AttributeType.MutliSelect:
        const multiSelected = picklistDefinitions.filter((x: any) => {
          return value.selectedValues.includes(x.id);
        });

        return multiSelected.length !== 0
          ? multiSelected.map((x: any) => x.name).join()
          : undefined;
      case AttributeType.Currency:
        return value.amount || value.amount === 0 ? value.amount : undefined;
      case AttributeType.Document:
        return value.displayName ? value.displayName : undefined;
      default:
        return undefined;
    }
  };

  function filterAttributes(attribute: any) {
    if (showAttributesWithValue) {
      return attribute.value.attributeType !== AttributeType.Document &&
        returnValue(
          attribute.value.attributeType,
          attribute.value,
          attribute.picklistDefinitions
        ) ? (
        <li>
          <label>{attribute.name}</label>
          <p className="break-word">
            <CustomAttributeValue
              attributeType={attribute.value.attributeType}
              value={attribute.value}
              picklistDefinitions={attribute.picklistDefinitions}
              metadataJSON={attribute.metadataJSON}
            />
          </p>
        </li>
      ) : (
        <></>
      );
    } else {
      return attribute.value.attributeType !== AttributeType.Document ? (
        <li>
          <label>{attribute.name}</label>
          <p className="break-word">
            <CustomAttributeValue
              attributeType={attribute.value.attributeType}
              value={attribute.value}
              picklistDefinitions={attribute.picklistDefinitions}
              metadataJSON={attribute.metadataJSON}
            />
          </p>
        </li>
      ) : (
        <></>
      );
    }
  }

  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const [notificationVisible, setNotificationVisible] = useState(false);
  const stageDocId = claimStageData
    ? claimStageData.instanceData.stageDocumentId
    : undefined;
  const caseId = data ? data?.claimSummary?.caseId : undefined;
  const { data: getClaimStatus } = useGetClaimStatusApiDataQuery(
    claimStageData?.definitionIds.claimStatusDefinitionId,
    { skip: !claimStageData?.definitionIds.claimStatusDefinitionIds }
  );
  const caseData = useCase();
  const permissions = useSelector((state: any) => state.permissions);
  const { Claim, Document, ClaimStageInstance, ClaimStatusInstance } =
    permissions;
  const handleFileDownload = (e: any) => {
    e.preventDefault();
    downloadDocument({
      caseId: caseId,
      documentId: stageDocId,
      fileName: claimStageData?.instanceData?.stageDocumentName,
    });
  };

  useEffect(() => {
    if (!showStageEdit && !showDocumentEdit) {
      refetch();
    }
    // eslint-disable-next-line
  }, [showStageEdit, showDocumentEdit]);
  function claimAssigneeContact(getAssignneData: any) {
    let filteredData = getAssignneData?.filter((getPrimaryData: any) => {
      if (getPrimaryData?.isPrimaryContact === true) {
        return true;
      } else {
        return false;
      }
    });
    return filteredData;
  }
  function handlecreditornav(creditorId: string, pathName: string) {
    if (creditorId) {
      navigate(pathName, { state: { from: creditorId } });
    }
  }
  const copiedToClipBoard = (
    event: React.MouseEvent<HTMLButtonElement>,
    contactDetails: any
  ) => {
    event.stopPropagation();
    setNotificationVisible(false);
    setNotification({
      ...notification,
      show: false,
      message: "",
      type: "success",
    });
    if (contactDetails && contactDetails.length > 0) {
      const namePart = [contactDetails[0].firstName, contactDetails[0].lastName]
        .filter(Boolean)
        .join(" ")
        .trim();
      const addressPart = [
        contactDetails[0].address1,
        contactDetails[0].address2,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();
      const cityStatePostalPart = [
        contactDetails[0].city,
        contactDetails[0].provinceState,
        contactDetails[0].postalCode,
      ]
        .filter(Boolean)
        .join(", ")
        .trim();
      const addressParts = [namePart, addressPart, cityStatePostalPart];
      const formattedAddress = addressParts
        .filter((part) => part && part.trim() !== "")
        .join("\n");
      navigator.clipboard
        .writeText(formattedAddress)
        .then(() => {
          setNotificationVisible(true);
          setNotification({
            ...notification,
            show: true,
            message: t("global.globalNotifications.copiedToClipboard"),
            type: "success",
          });
        })
        .catch((err) => {
          setNotificationVisible(true);
          setNotification({
            ...notification,
            show: true,
            message: t("global.globalNotifications.copiedToClipboardError"),
            type: "error",
          });
        });
    }
  };
  return (
    <>
      {notificationVisible && (
        <NotificationGrid
          show={notification.show}
          message={notification.message}
          type={notification.type}
        />
      )}
      <div className="motif-container case-summary-form pad-v-20 mar-t-20">
        <div className="motif-row justify-content-between align-items-center">
          <div className="motif-col-4">
            <div className="motif-body1-default-regular page-title">
              {t("pages.claims.claimsviewTab.title")}
            </div>
            <div className="motif-body2-default-regular page-description">
              {t("pages.claims.claimsviewTab.description")}
            </div>
          </div>
          <div className="motif-col-4">
            {havingEditPermission(Claim) && (
              <CommonTooltipWrapper
                tooltipTitle={t("global.globalActions.edit")}
              >
                <MotifButton
                  size="small"
                  type="submit"
                  variant={EDIT_BUTTON_VARIANT}
                  onClick={() => setEditPage(true)}
                >
                  {t("global.globalActions.edit")}
                </MotifButton>
              </CommonTooltipWrapper>
            )}
          </div>
        </div>
      </div>
      <div className="motif-container main-container ccwp_claim_summary_form pad-t-20 mar-b-20 pad-b-20">
        {data?.claimSummary.length === 0 ? (
          <p>{t("global.globalNotifications.noDatFound")}</p>
        ) : isLoading ? (
          <MotifProgressLoader show variant="default" className="mar-b-20" />
        ) : data?.claimSummary ? (
          <div className="ccwp_claim_summary_form_subwrapper">
            <div className="motif-row">
              <div className="motif-col-lg-8 pad-0">
                <ul className="ccwp_claim_summary_details">
                  <li>
                    <label>
                      {t("pages.claims.commonFieldLabels.creditorName")}
                    </label>

                    <p
                      style={{ cursor: "pointer" }}
                      className="text-bold-underline"
                      onClick={() =>
                        handlecreditornav(
                          data?.claimSummary?.creditorId,
                          `/case/${caseId}/creditor/${data?.claimSummary?.creditorId}`
                        )
                      }
                    >
                      {data?.claimSummary?.creditorName}
                    </p>
                  </li>
                  <li>
                    <label>{t("pages.claims.commonFieldLabels.claimId")}</label>
                    <p>{data?.claimSummary?.claimReference}</p>
                  </li>
                  <li>
                    <label>
                      {t("pages.claims.commonFieldLabels.initialFileDate")}
                    </label>
                    <p>
                      {
                        dateFunc(data?.claimSummary?.initialFileDate)
                          .formattedDateOnly
                      }
                    </p>
                  </li>
                  <li>
                    <label>
                      {t("pages.claims.commonFieldLabels.debtorName")}
                    </label>
                    <p
                      style={{ cursor: "pointer" }}
                      className="text-bold-underline"
                      onClick={() =>
                        handlecreditornav(
                          data?.claimSummary?.debtorId,
                          `/case/${caseId}/debtor/${data?.claimSummary?.debtorId}`
                        )
                      }
                    >
                      {data?.claimSummary?.debtorName}
                    </p>
                  </li>
                  <li>
                    <label>{t("pages.claims.commonFieldLabels.source")}</label>
                    <p>{data?.claimSummary?.source}</p>
                  </li>
                  <li>
                    <label>
                      {t("pages.claims.commonFieldLabels.lastUpdatedDate")}
                    </label>
                    <p>
                      {dateFunc(data?.claimSummary?.updatedOn)
                        .formattedDateTime +
                        " " +
                        caseData?.abbreviation}
                    </p>
                  </li>
                </ul>
              </div>
              <div className="motif-col-lg-4 pad-0">
                <ul className="ccwp_claim_summary_status">
                  {" "}
                  <li>
                    <label>
                      {t(
                        "pages.claims.claimsviewTab.formLabelDetails.claimStage"
                      )}
                    </label>
                    <MotifChip onRemove={function Ua() {}} title="Chip Title">
                      {claimStageData?.instanceData?.claimStageName}
                    </MotifChip>
                  </li>
                  <li>
                    <label>
                      {t(
                        "pages.claims.claimsviewTab.formLabelDetails.actionStatus"
                      )}
                    </label>
                    <div className="display-flex align-items-center">
                    <div>
                    <MotifChip
                      onRemove={function Ua() {}}
                      title="Chip Title"
                      variant="success"
                    >
                      {claimStageData?.instanceData?.claimStatusName}
                    </MotifChip>
                    </div>
                    {(havingEditPermission(ClaimStageInstance) ||
                      havingEditPermission(ClaimStatusInstance)) && (
                      <span
                        className="mar-l-5"
                        onClick={() => setShowEdit(true)}
                      >
                        <CommonTooltipWrapper
                          tooltipTitle={t("global.globalActions.edit")}
                        >
                          <MotifIcon
                            iconFunction={IconoirEditPencil}
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            size="15"
                          />
                        </CommonTooltipWrapper>
                      </span>
                    )}
                    </div>
                  </li>
                  <li>
                    <label>
                      {t(
                        "pages.claims.claimsviewTab.formLabelDetails.stageDocument"
                      )}
                    </label>
                    <label
                      className="stage-docoument"
                      style={
                        getClaimStatus?.isResolveStatus
                          ? { pointerEvents: "none", cursor: "none" }
                          : {}
                      }
                    >
                      {claimStageData?.instanceData?.stageDocumentName ? (
                        <a
                          href="/"
                          title={
                            claimStageData?.instanceData?.stageDocumentName
                          }
                          onClick={handleFileDownload}
                        >
                          {claimStageData?.instanceData?.stageDocumentName}
                        </a>
                      ) : (
                        <span>
                          {t(
                            "pages.claims.claimsviewTab.formLabelDetails.noDocument"
                          )}
                        </span>
                      )}
                      {havingEditPermission(Document) && (
                        <CommonTooltipWrapper
                          tooltipTitle={t("global.globalActions.edit")}
                        >
                          <button onClick={() => setDocumentEdit(true)}>
                            <MotifIcon
                              iconFunction={IconoirEditPencil}
                              stroke="#FFFFFF"
                              strokeWidth="2"
                              size="15"
                            />
                          </button>
                        </CommonTooltipWrapper>
                      )}
                    </label>
                  </li>
                  <li className="pad-r-0">
                    <label>
                      {t(
                        "pages.claims.claimsviewTab.formLabelDetails.changeStatusDate"
                      )}
                    </label>
                    <p>
                      {dateFunc(claimStageData?.instanceData?.statusUpdatedOn)
                        .formattedDateTime +
                        " " +
                        caseData?.abbreviation}
                    </p>
                  </li>
                  {claimStageData?.instanceData?.isOverdue && (
                    <div
                      className="display-flex  justify-content-end pad-b-0"
                    >
                      <div style={{height:"2rem"}}>
                        <MotifChip
                          onRemove={function Ua() {}}
                          variant="error"
                          title="Overdue"
                        >
                          Overdue
                        </MotifChip>
                      </div>
                    </div>
                  )}
                </ul>
              </div>
            </div>
          </div>
        ) : null}

        <div className="ccwp_claim_summary_black_accordian">
          {/* <MotifAccordion
            onClose={function Ua() {}}
            onOpen={function Ua() {}}
            useChevronIcon={true}
            alignIconRight={true}
          >
            <MotifAccordionTrigger>Attributes</MotifAccordionTrigger>
            <MotifAccordionContent className="ccwp_claim_summary_accordian_wrapper">
              <div className="motif-row justify-content-between">
                <div className="motif-col-4 ccwp_claim_summary_accordian_subwrapper">
                  <label>Claim ID</label>
                  <p>14657</p>
                </div>
                <div className="motif-col-4 ccwp_claim_summary_accordian_subwrapper">
                  <label>Claim ID</label>
                  <p>Lorem ipsum.</p>
                </div>
                <div className="motif-col-4 ccwp_claim_summary_accordian_subwrapper">
                  <label>Last Updated Date</label>
                  <p>Dec 20, 2023</p>
                </div>
                <div className="motif-col-4 ccwp_claim_summary_accordian_subwrapper">
                  <label>Debtor</label>
                  <p>New case company - 1023</p>
                </div>
              </div>
            </MotifAccordionContent>
          </MotifAccordion> */}

          {error ? (
            <MotifErrorMessage
              style={{
                textAlign: "center",
                display: "block",
                alignItem: "center",
              }}
            >
              {t("global.globalNotifications.wentWrong")}{" "}
            </MotifErrorMessage>
          ) : isLoading ? (
            <MotifProgressLoader show variant="default" />
          ) : data ? (
            <>
              <MotifAccordion
                onClose={function Ua() {}}
                onOpen={function Ua() {}}
                useChevronIcon={true}
                alignIconRight={true}
              >
                <MotifAccordionTrigger>
                  {t("pages.claims.commonFieldLabels.attributes")}
                </MotifAccordionTrigger>
                <MotifAccordionContent className="ccwp_claim_summary_accordian_wrapper">
                  <div className="ccwp_claim_summary_white_accordian">
                    <div className="motif-row ">
                      <MotifCheckbox
                        className="motif-col-lg-4 attribute-field"
                        checked={showAttributesWithValue}
                        onChange={(e: any) =>
                          setShowAttributesWithValue(e.target.checked)
                        }
                      >
                        {t("global.globalActions.showAttributesWithValues")}
                      </MotifCheckbox>
                    </div>
                    <ul className="ccwp_claim_summary_details">
                      {data?.customAttributes.length === 0 ? (
                        <span>{t("pages.claims.noAttributesLabel")}</span>
                      ) : (
                        data?.customAttributes.map((attribute: any) => {
                          return filterAttributes(attribute);
                        })
                      )}
                    </ul>
                  </div>
                </MotifAccordionContent>
              </MotifAccordion>

              <MotifAccordion
                onClose={function Ua() {}}
                onOpen={function Ua() {}}
                useChevronIcon={true}
                alignIconRight={true}
                open={true}
              >
                <MotifAccordionTrigger>
                  {t("pages.claims.commonFieldLabels.assignees")}
                </MotifAccordionTrigger>
                <MotifAccordionContent className="ccwp_claim_summary_accordian_wrapper">
                  <div
                    className="ccwp_claim_summary_white_accordian"
                    style={{ position: "relative" }}
                  >
                    {data?.claimAssignee ? (
                      <MotifAccordion
                        onClose={function Ua() {}}
                        onOpen={function Ua() {}}
                        style={{
                          flex: "1",
                        }}
                        alignIconRight={true}
                        useChevronIcon={true}
                      >
                        <MotifAccordionTrigger>
                          <div className="ccwp_claim_summary_white">
                            <label>
                              {t("pages.claims.commonFieldLabels.asigneeName")}
                            </label>
                            <p className="text-bold-underline">
                              {data?.claimAssignee?.assigneeName}
                            </p>
                            <div
                              style={{
                                position: "absolute",
                                right: "60px",
                                top: "13px",
                              }}
                            >
                              <CommonTooltipWrapper
                                tooltipTitle={t(
                                  "global.globalActions.copyToClipboard"
                                )}
                              >
                                <MotifIconButton
                                  size="small"
                                  onClick={(event: any) =>
                                    copiedToClipBoard(
                                      event,
                                      claimAssigneeContact(
                                        data?.claimAssignee?.contact
                                      )
                                    )
                                  }
                                  type="button"
                                >
                                  {getCommonCopyImg()}
                                </MotifIconButton>
                              </CommonTooltipWrapper>
                            </div>
                          </div>
                        </MotifAccordionTrigger>
                        <MotifAccordionContent>
                          {claimAssigneeContact(
                            data?.claimAssignee?.contact
                          ).map((getPrimaryData: any) => {
                            return (
                              <>
                                <ul className="ccwp_claim_summary_details">
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.firstName"
                                      )}
                                    </label>
                                    <p
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handlecreditornav(
                                          data?.claimAssignee?.assigneeId,
                                          `/case/${caseId}/creditor/${data?.claimAssignee?.assigneeId}`
                                        )
                                      }
                                    >
                                      {getPrimaryData?.firstName &&
                                        getPrimaryData?.firstName}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.lastName"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.lastName
                                        ? "-"
                                        : getPrimaryData?.lastName}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.businessName"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.businessName
                                        ? "-"
                                        : getPrimaryData?.businessName}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.phone"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.phone
                                        ? "-"
                                        : getPrimaryData?.phone}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.email"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.email
                                        ? "-"
                                        : getPrimaryData?.email}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.address1"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.address1
                                        ? "-"
                                        : getPrimaryData?.address1}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.address2"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.address2
                                        ? "-"
                                        : getPrimaryData?.address2}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.country"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.country
                                        ? "-"
                                        : getPrimaryData?.country}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t("pages.claims.commonFieldLabels.city")}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.city
                                        ? "-"
                                        : getPrimaryData?.city}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.provincestate"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.provinceState && !getPrimaryData?.provinceStateCode
                                        ? "-"
                                        : getPrimaryData?.provinceStateCode || getPrimaryData?.provinceState}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.postalCode"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.postalCode
                                        ? "-"
                                        : getPrimaryData?.postalCode}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.lastUpdatedOn"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.updatedOn
                                        ? "-"
                                        : dateFunc(getPrimaryData?.updatedOn)
                                            .formattedDateTime +
                                          " " +
                                          caseData?.abbreviation}
                                    </p>
                                  </li>
                                  <li>
                                    <label>
                                      {t(
                                        "pages.claims.commonFieldLabels.lastUpdatedBy"
                                      )}
                                    </label>
                                    <p>
                                      {!getPrimaryData?.updatedBy
                                        ? "-"
                                        : getPrimaryData?.updatedBy}
                                    </p>
                                  </li>
                                </ul>
                              </>
                            );
                          })}
                        </MotifAccordionContent>
                      </MotifAccordion>
                    ) : (
                      <></>
                    )}
                  </div>
                </MotifAccordionContent>
              </MotifAccordion>
            </>
          ) : null}
        </div>
      </div>
      <StageStatusPopup
        key={parameter?.claimId}
        show={showStageEdit}
        setShow={setShowEdit}
        claimId={parameter?.claimId!}
      />
      <DocumentPopUp
        show={showDocumentEdit}
        setShow={setDocumentEdit}
        caseId={caseId}
        currentInstanceData={claimStageData}
        resolvedStatus={getClaimStatus?.isResolveStatus}
      />
    </>
  );
};
